// components/Auth/Login.js
import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import styles from "../../styles/Auth.module.css";

export default function Login() {
  const { handleLogin } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const setValidity = (e, msg) => e.target.setCustomValidity(msg || "");
  const clearValidity = (e) => e.target.setCustomValidity("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await handleLogin(email, password);
      navigate("/documents");
    } catch (err) {
      setError("Błędny email lub hasło");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.authBg}>
      <div className={styles.mainContent}>
        <Link to="/">
          <img src="/logo2.png" alt="Paperly logo" className={styles.authLogoStandalone} />
        </Link>
        <form onSubmit={onSubmit} className={styles.authForm} autoComplete="on" aria-label="Logowanie">
          <div className={styles.authHeader}>
            <h1 className={styles.authTitle}>Zaloguj się</h1>
            <p className={styles.authSubtitle}>Witaj ponownie! Wprowadź swoje dane, aby uzyskać dostęp.</p>
          </div>
          
          <div className={styles.inputGroup}>
            <input
              id="email"
              value={email}
              onChange={(e) => { clearValidity(e); setEmail(e.target.value); }}
              onInvalid={(e) => setValidity(e, "Wpisz poprawny adres e‑mail.")}
              type="email"
              required
              className={styles.inputField}
              autoFocus
              autoComplete="email"
              placeholder=" " 
            />
            <label htmlFor="email" className={styles.inputLabel}>Adres e-mail</label>
          </div>

          <div className={styles.inputGroup}>
            <input
              id="password"
              value={password}
              onChange={(e) => { clearValidity(e); setPassword(e.target.value); }}
              onInvalid={(e) => setValidity(e, "Wpisz hasło.")}
              type="password"
              required
              className={styles.inputField}
              autoComplete="current-password"
              placeholder=" "
            />
            <label htmlFor="password" className={styles.inputLabel}>Hasło</label>
          </div>

          {error && <div className={styles.authError}>{error}</div>}
          
          <button type="submit" className={styles.authButton} disabled={loading}>
            {loading ? "Logowanie..." : "Zaloguj się"}
          </button>

          <div className={styles.authFooter}>
            <Link to="/reset-password" className={styles.authLink}>Nie pamiętasz hasła?</Link>
          </div>

          <div className={styles.authFooter}>
            <span>Nie masz konta? </span>
            <Link to="/register" className={styles.authLink}>Zarejestruj się</Link>
          </div>
        </form>
      </div>
      <footer className={styles.authPageFooter}>
        <Link to="/" className={styles.authPageFooterLink}>Strona główna</Link>
        <span className={styles.authPageFooterSeparator}>•</span>
        <Link to="/polityka-prywatnosci" className={styles.authPageFooterLink}>Polityka Prywatności</Link>
        <span className={styles.authPageFooterSeparator}>•</span>
        <Link to="/regulamin" className={styles.authPageFooterLink}>Regulamin</Link>
      </footer>
    </div>
  );
}
